export default __webpack_public_path__ + "resources/icons/n412-45e1.webp";